'use client';

import type {ReactNode} from 'react';
import {observer} from 'mobx-react-lite';

const Layout = observer(({children}: { children: ReactNode }) => {
    // TODO: Add proper authentication check when needed
    // if (!authStore.isAuthenticated) {
    //   redirect('/sign-up');
    // }

    return <>{children}</>;
});

export default Layout;
